import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { RxCross2 } from "react-icons/rx";
import heic2any from "heic2any";

const AddPerson = () => {
  const history = useHistory();
  const jwtToken = localStorage.getItem("jwt_token");
  const { search } = useLocation();
  const paramIdSeprator = (param) => {
    const paramId = param.split("=");
    return paramId[1];
  };

  const [selectedImage, setSelectedImage] = useState(null);
  const [imageKey, setImageKey] = useState(Date.now());
  const [person, setPerson] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    password: "",
    employee_id: "",
  });

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const fileType = file.type;

    if (fileType === "image/heic" || fileType === "image/heif") {
      try {
        const convertedBlob = await heic2any({
          blob: file,
          toType: "image/jpeg",
          quality: 0.8,
        });

        const reader = new FileReader();
        reader.onloadend = () => {
          setSelectedImage(reader.result);
          setImageKey(Date.now());
        };
        reader.readAsDataURL(convertedBlob);
      } catch (error) {
        console.error("HEIC conversion error:", error);
        toast.error("Failed to convert HEIC image.");
      }
    } else {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result);
        setImageKey(Date.now()); 
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = () => {
    setSelectedImage(null);
    setImageKey(Date.now());
  };

  const addCacheBuster = (url) => {
    if (!url) return url;
    if (url.startsWith('data:')) return url;
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}t=${imageKey}`;
  };

  const add = () => {
    const url = `${process.env.REACT_APP_API_URL}/people`;
    const body = { ...person, profile_image: selectedImage };

    fetch(url, {
      method: "post",
      body: JSON.stringify(body),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.data) {
          toast.success("Data Added");
          history.push("/admin-person");
        } else {
          toast.error("Email already exists.");
        }
      });
  };

  const update = (id) => {
    const url = `${process.env.REACT_APP_API_URL}/people/${id}`;
    fetch(url, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        const details = data.data.people_details;
        setPerson({
          first_name: details.first_name,
          last_name: details.last_name,
          email: details.email,
          phone_number: details.phone_number,
          employee_id: details.employee_id,
          password: "",
        });
        setSelectedImage(details.profile_image);
        setImageKey(Date.now());
      });
  };

  const onChangeHandler = (e) => {
    setPerson({ ...person, [e.target.id]: e.target.value });
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();
    if (search) {
      const id = paramIdSeprator(search);
      const url = `${process.env.REACT_APP_API_URL}/people/${id}`;
      const body = { ...person, profile_image: selectedImage };

      fetch(url, {
        method: "post",
        body: JSON.stringify(body),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwtToken}`,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.error) {
            toast.error("Something went wrong!!!");
          } else {
            if (data.data?.people_details?.profile_image) {
              setSelectedImage(data.data.people_details.profile_image);
              setImageKey(Date.now());
            }
            toast.success("Data Updated");
            setTimeout(() => {
              history.push("/admin-person");
              clearData();
            }, 500);
          }
        })
        .catch((error) => {
          console.error("Update error:", error);
          toast.error("Failed to update person");
        });
    } else {
      add();
      clearData();
    }
  };

  const clearData = () => {
    setPerson({
      first_name: "",
      last_name: "",
      email: "",
      phone_number: "",
      password: "",
      employee_id: "",
    });
    setSelectedImage(null);
    setImageKey(Date.now());
  };

  useEffect(() => {
    if (search) {
      const id = paramIdSeprator(search);
      update(id);
    }
  }, [search]);

  return (
    <div>
      <div className="row">
        <div className="col-12 mt-1">
          <h6>{search ? "Update Person" : "Add Person"}</h6>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="d-flex flex-column align-items-center mb-2">
            <label
              className="mb-2"
              style={{ fontWeight: 500, fontSize: "16px" }}
            >
              Profile Photo
            </label>

            {selectedImage ? (
              <div
                style={{
                  position: "relative",
                  width: "150px",
                  height: "150px",
                }}
              >
                <img
                  key={imageKey}
                  src={addCacheBuster(selectedImage)}
                  alt="Preview"
                  className="img-thumbnail rounded-circle"
                  style={{
                    width: "150px",
                    height: "150px",
                    objectFit: "cover",
                  }}
                />
                <button
                  type="button"
                  onClick={handleRemoveImage}
                  style={{
                    position: "absolute",
                    top: "-10px",
                    right: "-10px",
                    backgroundColor: "red",
                    color: "white",
                    border: "none",
                    borderRadius: "50%",
                    width: "28px",
                    height: "28px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                  }}
                >
                  <RxCross2 size={16} />
                </button>
              </div>
            ) : (
              <label htmlFor="upload-image">
                <div
                  className="d-flex justify-content-center align-items-center border rounded-circle"
                  style={{
                    width: "150px",
                    height: "150px",
                    border: "2px dashed #ccc",
                    cursor: "pointer",
                    fontSize: "14px",
                    textAlign: "center",
                    padding: "20px",
                  }}
                >
                  Upload your profile photo
                </div>
                <input
                  type="file"
                  accept="image/png, image/jpeg, image/jpg, image/webp, image/heic, image/heif"
                  id="upload-image"
                  onChange={handleImageUpload}
                  style={{ display: "none" }}
                />
              </label>
            )}
          </div>
        </div>
      </div>

      <form onSubmit={onSubmitHandler}>
        <div className="row g-2">
          <div className="col-md-6">
            <label htmlFor="first_name">First Name:</label>
            <input
              required
              type="text"
              className="form-control"
              id="first_name"
              value={person.first_name}
              onChange={onChangeHandler}
            />
          </div>

          <div className="col-md-6">
            <label htmlFor="last_name">Last Name:</label>
            <input
              type="text"
              className="form-control"
              id="last_name"
              value={person.last_name}
              onChange={onChangeHandler}
            />
          </div>

          <div className="col-md-6">
            <label htmlFor="email">Email:</label>
            <input
              required
              type="email"
              className="form-control"
              id="email"
              value={person.email}
              onChange={onChangeHandler}
            />
          </div>

          <div className="col-md-6">
            <label htmlFor="phone_number">Phone Number:</label>
            <input
              type="text"
              className="form-control"
              id="phone_number"
              value={person.phone_number}
              onChange={onChangeHandler}
            />
          </div>

          <div className="col-md-6">
            <label htmlFor="employee_id">Employee ID:</label>
            <input
              type="text"
              className="form-control"
              id="employee_id"
              value={person.employee_id}
              onChange={onChangeHandler}
            />
          </div>

          <div className="col-md-6">
            <label htmlFor="password">{search ? "Change" : "Gen."} Password:</label>
            <input
              type="password"
              className="form-control"
              id="password"
              value={person.password}
              onChange={onChangeHandler}
            />
          </div>
        </div>

        <div className="mt-4">
          <button type="submit" className="btn bg_color">
            {search ? "Update" : "Add"} Person
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddPerson;
